import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { DepartmentAvatarComponent } from '@modules/department/components/department-avatar/department-avatar.component';
import { DetectTruncationDirective } from '@modules/shared/directives/detect-truncation.directive';
import { LicenseState } from '@pixacare/domain';
import { TuiExpand, TuiHint, TuiLink, TuiNotification, TuiScrollbar } from '@taiga-ui/core';
import { TuiBadge, TuiChevron, TuiFade } from '@taiga-ui/kit';
import { SidebarDepartmentSkeletonComponent } from './sidebar-department-skeleton/sidebar-department-skeleton.component';
import { MenuBuilderService } from 'src/app/modules/dashboard/sidebar/menu-builder.service';
import { environment } from 'src/environments/environment';
import { ChatService } from '../../chat/chat.service';
import { MessageGroupService } from '../../chat/message-group.service';
import { ClientPickerComponent } from '../../client/client-picker/client-picker.component';
import { DataConsumptionComponent } from '../../paywall/data-consumption/data-consumption.component';
import { AnimateFadeDirective } from '../../shared/directives/animate-fade.directive';
import { UserAccountCardComponent } from '../../user/user-account-card/user-account-card.component';
import { SidebarLinkComponent } from './sidebar-link/sidebar-link.component';
import { SidebarOpenFolderService } from './sidebar-open-folder.service';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'pxc-sidebar',
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MenuBuilderService, SidebarOpenFolderService, ChatService, MessageGroupService],
  host: { class: 'block h-full' },
  imports: [
    CommonModule,
    RouterModule,
    TuiScrollbar,
    TuiHint,
    TuiNotification,
    TuiExpand,
    TuiLink,
    UserAccountCardComponent,
    DepartmentAvatarComponent,
    DataConsumptionComponent,
    ClientPickerComponent,
    AnimateFadeDirective,
    TuiBadge,
    DetectTruncationDirective,
    TuiChevron,
    TuiFade,
    SidebarDepartmentSkeletonComponent,
    SidebarLinkComponent,
    TranslocoDirective,
  ],
})
export class SidebarComponent {
  readonly menuBuilderService = inject(MenuBuilderService);
  readonly sidebarService = inject(SidebarService);
  private readonly sidebarFolderService = inject(SidebarOpenFolderService);

  @Input() collapsed = false;

  isTitleTruncated = false;

  readonly LicenseState = LicenseState;

  readonly cdnClientBaseUrl: string = environment.cdn.clientBaseUrl;
  readonly environmentName = !environment.production ? environment.name : null;
  readonly environmentColor = environment.color;

  readonly openDepartment$ = this.sidebarFolderService.openDepartment$;

  changeActiveClient(clientCode: string): void {
    this.sidebarService.updateLocation(clientCode);
  }

  toggleFolder(folderId: number, isExpanded: boolean): void {
    this.sidebarFolderService.setOpenDepartment(isExpanded ? null : +folderId);
  }
}
